import { CommonModule } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LedgerImportDocumentTypeNames, LedgerImportDocumentTypes, LedgerImportEntity } from '../../../dave-data-module/entities/ledger-import.entity';
import { State } from '../../../dave-data-module/State';
import { AccountsReceivableLedgerActionTypes, LedgerImportActionTypes } from '../../../dave-data-module/State/actions/accounting.actions';
import { BaseActionTypes } from '../../../dave-data-module/State/actions/base.actions';
import {
    getLedgerImportById,
    getLedgerImports,
} from '../../../dave-data-module/State/selectors/ledger-import.selector';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { appMatDialogDefaultConfig } from '../../../helper/helper';
import { LoadingService } from '../../../services/loading.service';
import {
    LedgerImportSelectTableComponent,
    LedgerImportSelectTableComponentLedgerImportFilter,
} from '../ledger-import-select-table/ledger-import-select-table.component';
import { NewPartialInvoiceComponent } from '../new-partial-invoice/new-partial-invoice.component';
import { ArlDataService } from '../../../dave-data-module/services/arl-data.service';
import { ArlInputBuilderService } from '../../../dave-data-module/services/arl-input-builder.service';
import { _getArlChildren } from '../arl-calculation/arl-calculation.helper';
import { SelectArlDialogService } from '../select-arl-dialog/select-arl-dialog.service';
export interface NewClosingInvoiceComponentDialogData {
    FilterLedgerImports?: {
        CommissionId?: number;
        CustomerId?: number;
    };
}
export type NewClosingInvoiceComponentDialogReturnData =
    | undefined
    | {
          LedgerImportCreated: number;
      };
@Component({
    selector: 'app-new-closing-invoice',
    standalone: true,
    imports: [CommonModule, AppButtonModule, LedgerImportSelectTableComponent, MatDialogModule],
    templateUrl: './new-closing-invoice.component.html',
    styleUrls: ['./new-closing-invoice.component.scss'],
})
export class NewClosingInvoiceComponent {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        height: '95vh',
        minWidth: '60vw',
    };
    title = LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.ClosingInvoice) + ' erstellen';
    selectedRootLedgerImport: number | undefined;
    selectedLedgerImports: number[] = [];

    // selectableRootLedgerImports$: Observable<number[]>;
    // selectablePartialLedgerImports$: Observable<number[]>;

    readonly selectableRootLedgerImportsFilter: LedgerImportSelectTableComponentLedgerImportFilter;
    readonly selectablePartialLedgerImportsFilter: LedgerImportSelectTableComponentLedgerImportFilter;

    readonly selectableSrcLedgerImportsDocumentTypesDefaultFilter = [
        LedgerImportDocumentTypes.Invoice,
        LedgerImportDocumentTypes.Offer,
        LedgerImportDocumentTypes.OfferConfirmation,
        LedgerImportDocumentTypes.PartialInvoice,
        LedgerImportDocumentTypes.Measurement,
    ];
    readonly selectablePrevLedgerImportsDocumentTypesDefaultFilter = [
        LedgerImportDocumentTypes.Invoice,
        LedgerImportDocumentTypes.PartialInvoice,
        LedgerImportDocumentTypes.Cancellation,
        LedgerImportDocumentTypes.Credit,
    ];
    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) dialogData: NewClosingInvoiceComponentDialogData,
        private dialogRef: MatDialogRef<NewClosingInvoiceComponent, NewClosingInvoiceComponentDialogReturnData>,
        private store: Store<State>,
        protected ls: LoadingService,
        private actions$: Actions,
        private arlInputBuilder: ArlInputBuilderService,
        private arlDataService: ArlDataService,
        private selectArlDialogService: SelectArlDialogService,
    ) {
        this.selectableRootLedgerImportsFilter = {
            customerIds: dialogData?.FilterLedgerImports?.CustomerId ? [dialogData.FilterLedgerImports.CustomerId] : [],
            commissionIds: dialogData?.FilterLedgerImports?.CommissionId ? [dialogData.FilterLedgerImports.CommissionId] : [],
            // documentTypes: LedgerImportEntity.CanBeClosingInvoiceRootDocumentTypes,
            documentTypes: null,
        }
        this.selectablePartialLedgerImportsFilter = {
            customerIds: dialogData?.FilterLedgerImports?.CustomerId ? [dialogData.FilterLedgerImports.CustomerId] : [],
            commissionIds: dialogData?.FilterLedgerImports?.CommissionId ? [dialogData.FilterLedgerImports.CommissionId] : [],
            // documentTypes: [LedgerImportDocumentTypes.Invoice, LedgerImportDocumentTypes.PartialInvoice, LedgerImportDocumentTypes.Cancellation, LedgerImportDocumentTypes.Credit]
            documentTypes: null,
        }
        // console.log(dialogData?.FilterLedgerImports)
        // this.selectableRootLedgerImports$ = this.store.select(getLedgerImports).pipe(
        //     map((lis) => lis.filter((l) => l.canBeClosingInvoiceRoot)),
        //     map((lis) => {
        //         let ret = lis;
        //         if (dialogData?.FilterLedgerImports?.CommissionId) {
        //             ret = ret.filter((li) => li.CommissionId === dialogData.FilterLedgerImports.CommissionId);
        //         }
        //         console.log(ret.length);
        //
        //         if (dialogData?.FilterLedgerImports?.CustomerId) {
        //             ret = ret.filter((li) => li.CustomerId === dialogData.FilterLedgerImports.CustomerId);
        //         }
        //         console.log(ret.length);
        //
        //         return ret;
        //     }),
        //     map((lis) => lis.map((l) => l.Id)),
        // );
        // this.selectablePartialLedgerImports$ = this.store.select(getLedgerImports).pipe(
        //     map((lis) => lis.filter((l) => l.DocumentType === LedgerImportDocumentTypes.Invoice || l.DocumentType === LedgerImportDocumentTypes.PartialInvoice || l.DocumentType === LedgerImportDocumentTypes.Cancellation || l.DocumentType === LedgerImportDocumentTypes.Credit)),
        //     map((lis) => {
        //         let ret = lis;
        //         if (dialogData?.FilterLedgerImports?.CommissionId) {
        //             ret = ret.filter((li) => li.CommissionId === dialogData.FilterLedgerImports.CommissionId);
        //         }
        //         if (dialogData?.FilterLedgerImports?.CustomerId) {
        //             ret = ret.filter((li) => li.CustomerId === dialogData.FilterLedgerImports.CustomerId);
        //         }
        //         return ret;
        //     }),
        //     map((lis) => lis.map((l) => l.Id)),
        // );
    }

    private async selectArls(ledgerImportId: number) {
        const dialogRef = await this.selectArlDialogService.open({
            AllowQuantityManipulation: false,
            AllowQuantityTypeManipulation: false,
            AllowPriceManipulation: false,
            AllowBezeichnungManipulation: false,
            LiId: ledgerImportId,
            // LedgerImportDocumentType: this.Data.newOptionDefaultValues.LedgerImportDocumentType,
            showForceItemNumbers: true,
            forceItemNumbersDefaultOn: true,
            disableForceItemNumbers: true,
        });
        const response = await firstValueFrom(dialogRef.afterClosed());
        if (response) {
            return response.ArlOutput.map(a => a.Id);
        } else {
            return null;
        }
    }

   async submit() {
        if (this.selectedRootLedgerImport) {

            let selectedArls = await this.selectArls(this.selectedRootLedgerImport);
            if (!selectedArls) {
                return;
            }
            const arlDictionary = await firstValueFrom(this.arlDataService.selectAllArlsDict());



            const WithoutCalculation = [
                ...new Set(
                    selectedArls.flatMap(id =>
                        _getArlChildren(id, arlDictionary, true)
                    )
                ),
            ];

            const WithCalculation = [
                ...new Set(
                    selectedArls.flatMap(id =>
                        _getArlChildren(id, arlDictionary, false)
                    )
                ),
            ];

            const calculationArlIds = WithCalculation
                .filter(a => !WithoutCalculation.some(w => w.Id === a.Id))
                .map(a => a.Id);


            selectedArls = [
                ...new Set([
                    ...selectedArls,
                    ...calculationArlIds
                ])
            ];


            const rootLedgerImport = await firstValueFrom(this.store.select(getLedgerImportById({ id: this.selectedRootLedgerImport })));
            const arls = this.arlInputBuilder.buildArlInputs(selectedArls, arlDictionary, rootLedgerImport?.ARLCalculationPreChargeByType || []);



            firstValueFrom(this.actions$.pipe(ofType(LedgerImportActionTypes.CreateClosingInvoiceSuccess, LedgerImportActionTypes.CreateClosingInvoiceFailure))).then((action) => {
                if (action.type === LedgerImportActionTypes.CreateClosingInvoiceSuccess.type) {
                    firstValueFrom(this.actions$.pipe(ofType(AccountsReceivableLedgerActionTypes.UpdateMany,AccountsReceivableLedgerActionTypes.UpdateAll, BaseActionTypes.ErrorAction))).then((arlAction) => {
                        this.ls.endLoading('app-new-closing-invoice-submit');
                        if (arlAction.type === AccountsReceivableLedgerActionTypes.UpdateMany.type || arlAction.type === AccountsReceivableLedgerActionTypes.UpdateAll.type) {
                            const { Id } = action.Payload as LedgerImportEntity;
                            this.dialogRef.close({
                                LedgerImportCreated: Id,
                            });
                        }
                    });
                } else {
                    this.ls.endLoading('app-new-closing-invoice-submit');
                }
            });
            this.ls.startLoading('app-new-closing-invoice-submit');
            this.store.dispatch(
                LedgerImportActionTypes.CreateClosingInvoiceRequest({
                    Payload: {
                        rootId: this.selectedRootLedgerImport,
                        ledgerImportIds: this.selectedLedgerImports,
                        arls: arls
                    },
                }),
            );
        }
    }
}
